import styled from "styled-components";

export const Root = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;

export const ItemCard = styled.div`
	background: #fff;
	overflow: hidden;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
`;

export const HeaderButton = styled.button`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	padding: 16px 18px;

	background: transparent;
	border: 0;
	cursor: pointer;
	text-align: left;
`;

export const Question = styled.span`
	font-size: 16px;
`;

export const IconWrap = styled.span`
	width: 34px;
	height: 34px;
	display: grid;
	place-items: center;
	flex: 0 0 auto;
	transition: transform 180ms ease;

	&[data-open="true"] {
		transform: rotate(90deg);
	}
`;

export const Panel = styled.div`
	overflow: hidden;
	transition: height 220ms ease;
`;

export const Inner = styled.div`
	opacity: 1;
	transition: opacity 160ms ease;
`;

export const Answer = styled.div`
	padding: 0 18px 16px 18px;
	line-height: 1.55;
`;
